<template>
  <v-dialog
    v-model="setDialog"
    max-width="600"
    scrollable
  >
    <v-card data-cy="modal_cancelar_assinatura">
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
        data-cy="modal_titulo_cancelar_assinatura"
      >
        Cancelar assinatura
      </v-card-title>

      <v-card-text
        class="pt-2 pb-9"
        data-cy="modal_texto_cancelar_assinatura"
      >
        <p class="mb-0 body-1">
          Deseja realmente interromper novas cobranças deste serviço?
        </p>
      </v-card-text>

      <v-card-actions class="pt-9">
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="modal_btn_nao_cancelar_assinatura"
          @click="setDialog = false"
        >
          Não
        </v-btn>

        <v-btn
          color="primary"
          text
          data-cy="modal_btn_sim_cancelar_assinatura"
          :loading="loading"
          @click="cancelarAssinatura()"
        >
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiCompras from '@/api/compras';

export default {
  name: 'CancelarAssinatura',

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    codigoVenda: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    setDialog: {
      get() {
        return this.dialog;
      },
      set(v) {
        this.$emit('changeDialog', v);
      },
    },
  },

  methods: {
    async cancelarAssinatura() {
      let sucesso = true;
      this.loading = true;

      try {
        await ApiCompras.membershipCancel(this.codigoVenda);
      } catch (error) {
        sucesso = false;
      }

      this.loading = false;
      this.$emit('repostaApi', sucesso);
      this.$emit('changeDialog', false);
    },
  },
};
</script>
